const SKILLS = [{ label: 'Example' }, { label: 'Lorem' }];

export default SKILLS;
